import { createContext } from 'react';
import { BaseIntegrationProps } from './BaseIntegrationProps';
import { NoneIntegrationProps } from './Product/None/NoneIntegrationProps';
import { DEFAULT_OVERRIDE_TENANT_ID } from './integrationUtils';

export const IntegrationContext = createContext<BaseIntegrationProps>(new NoneIntegrationProps(document.body, DEFAULT_OVERRIDE_TENANT_ID));
